
import FormMixins from './FormMixins'
import { Component, Mixins } from 'vue-property-decorator'

@Component
export default class FormCounter extends Mixins(FormMixins) {
}
